// packages/console/src/api/config.ts
//
// API base configuration. Every service lives under a single configurable
// base (VITE_API_BASE, default the relative "/api") with a per-service path
// prefix, matching the panel map's named sources:
//   FT-6a tenancy   -> /api/tenancy
//   FT-2  upload     -> /api/upload
//   FT-3  jobs       -> /api/jobs
//   FT-4  telemetry  -> /api/telemetry
//   live  live-ingest control -> /api/live
// Keeping the base relative by default lets the console be served from the
// same origin as an edge that fans out to the services.

const rawBase = (import.meta.env.VITE_API_BASE as string | undefined) ?? "/api";

// Normalize away any trailing slash so joins are unambiguous.
const base = rawBase.replace(/\/+$/, "");

export const API_BASE = base;

export const servicePaths = {
  tenancy: `${base}/tenancy`,
  upload: `${base}/upload`,
  jobs: `${base}/jobs`,
  telemetry: `${base}/telemetry`,
  live: `${base}/live`,
} as const;

export type ServiceName = keyof typeof servicePaths;

// LIVE_SRT_INGEST is the public SRT ingest endpoint a broadcaster pushes to,
// with the stream key as the SRT streamid. It is deployment-specific (the live
// ingest service runs on aether), overridable via VITE_LIVE_SRT_INGEST, and
// defaults to aether's public ingest port.
export const LIVE_SRT_INGEST =
  (import.meta.env.VITE_LIVE_SRT_INGEST as string | undefined) ?? "srt://aether.evemeta.com:9000";
